import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { skillsQueryKey } from "./useSkills";

interface Args {
  skillId: string;
}

/** Remove the caller's subscription row. No-op if no row exists. */
export function useUnsubscribeSkill(orgId: string | undefined) {
  const { skillService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<void, Error, Args>({
    mutationFn: ({ skillId }) => skillService.unsubscribe(skillId, { orgId }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: skillsQueryKey(orgId) });
    },
  });
}
